export default __webpack_public_path__ + "static/media/login.1dca4849.svg";